import { render } from "./DetailLayout.vue?vue&type=template&id=57d98e14&scoped=true&ts=true"
import script from "./DetailLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./DetailLayout.vue?vue&type=script&setup=true&lang=ts"

import "./DetailLayout.vue?vue&type=style&index=0&id=57d98e14&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57d98e14"],['__file',"resources/js/vue/domain/invoice/components/detail/DetailLayout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "57d98e14"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('57d98e14', __exports__)) {
    api.reload('57d98e14', __exports__)
  }
  
  module.hot.accept("./DetailLayout.vue?vue&type=template&id=57d98e14&scoped=true&ts=true", () => {
    api.rerender('57d98e14', render)
  })

}


export default __exports__